
<div class="not-supported-page">
  <div class="image-wrapper">
    <img  src="assets/images/not_supported_icon.svg" alt="supported" width="300"
    height="300">
  
   <div class="header"> Your browser is not supported.</div>
  <div class="text-color">To use Pulse, We recommended using the latest version of chrome 59+, Safari 9+, Firefox 53+, Opera 50+, Internet Explorer 11+ or Edge 16+ .</div>
</div>
</div>